// classes
import MenuDesktop from "./modules/MenuDesktop"
import FadeInScroll from "./modules/FadeInScroll"
import Search from "./modules/Search"
import CloseMessageModal from "./modules/CloseMessageModal"
import MenuMobile from "./modules/MenuMobile"
import BootstrapWrapper from "./modules/BootstrapWrapper"
import ScrollDownOnClick from "./modules/ScrollDownOnClick"

// instantiate objects
const menuDesktop = new MenuDesktop()
const fadeInScroll = new FadeInScroll()
const search = new Search()
const closeMessageModal = new CloseMessageModal()
const menuMobile = new MenuMobile()
const scrollDownOnClick = new ScrollDownOnClick()
// const bootstrapWrapper = new BootstrapWrapper
